import { publishingDomainSwitchUrl } from "#/admin/legacy/call-center/publishing-domain-switch.js";

class ContentFrame {
  constructor() {
    this.patchHistoryMethods();
    this.checkForCallCenterAction();
    this.registerListeners();
  }

  patchHistoryMethods() {
    ["pushState", "replaceState"].forEach((type) => {
      history[type] = (...args) => {
        this.postMessage({ type, args });
        return History.prototype[type].apply(history, args);
      };
    });
  }

  checkForCallCenterAction() {
    const params = new URLSearchParams(document.location.search);
    const action = params.get("call_center_action");

    if (!action) {
      return;
    }

    this.cleanLocationHistory(params);

    // Wait for event handlers to be added
    setTimeout(function () {
      const data = decodeURIComponent(params.get("call_center_action_data"));
      jQuery(document).trigger(action, JSON.parse(data));
    });
  }

  cleanLocationHistory(params) {
    params.delete("call_center_action");
    params.delete("call_center_action_data");

    const url = new URL(document.location.href);
    url.search = params.toString();
    window.history.replaceState({}, document.title, url.href);
  }

  registerListeners() {
    window.addEventListener("message", this.handleIncomingMessageEvent);

    jQuery(document).on("click", "[data-twilio-outgoing-call-to]", (e) => this.handleTwilioOutgoingCallToClicked(e));
    jQuery(document).on("submit", "[data-behaviour~=switch-publishing-domain]", (e, args) =>
      this.handlePublishingDomainSwitch(e),
    );

    jQuery(document).on("call-center:set-last-viewed-patient-id", (e, patientId) =>
      this.handleSetLastViewedPatientId(patientId),
    );
    jQuery(document).on("call-center:call-number", (e, args) => this.handleTwilioOutgoingCallEvent(args));
  }

  handleIncomingMessageEvent(e) {
    if (!e.data) {
      return;
    }

    const { action, path, query = {}, ...args } = e.data;

    if (!action?.startsWith("call-center:")) {
      return;
    }

    if (action === "call-center:open-help") {
      window.openHelpModal(query.key, query.type);
      return;
    }

    if (document.location.pathname !== path) {
      const url = new URL(document.location.origin);
      url.pathname = path;

      for (let [key, value] of Object.entries(query)) {
        url.searchParams.set(key, value);
      }
      url.searchParams.set("call_center_action", action);
      url.searchParams.set("call_center_action_data", encodeURIComponent(JSON.stringify(args)));
      document.location.href = url.href;
    } else {
      jQuery(document).trigger(action, args);
    }
  }

  handleTwilioOutgoingCallToClicked(e) {
    const $target = jQuery(e.currentTarget);
    const args = {
      to: $target.data("twilio-outgoing-call-to"),
      from: $target.data("twilio-outgoing-call-from"),
      patient: $target.data("patient"),
      contact: $target.data("contact"),
    };
    this.postMessage({ type: "OutgoingCallEvent", args });
  }

  handlePublishingDomainSwitch(e) {
    e.preventDefault();

    const args = {
      url: publishingDomainSwitchUrl(e.currentTarget),
    };
    this.postMessage({ type: "NavigateMainFrameEvent", args });
  }

  handleSetLastViewedPatientId(patientId) {
    const args = {
      patientId: patientId,
    };
    this.postMessage({ type: "SetLastViewedPatientId", args });
  }

  handleTwilioOutgoingCallEvent(args) {
    this.postMessage({ type: "OutgoingCallEvent", args });
  }

  postMessage({ type, args }) {
    window.parent.postMessage({ type, args }, "*");
  }
}

window.ContentFrame = ContentFrame;
